import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Button, Modal, Form, Input, Select, message, Divider, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { useTranslation } from 'react-i18next';

function AssignBye(props) {
    const [form] = Form.useForm();
    const [players, setPlayers] = useState([]);
    const [isActive,setIsActive] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [selected, setSelected] = useState([]);
    const nameRef = useRef(null);
    const surnameRef = useRef(null);
    const [newplayerName, setNewplayerName] = useState("");
    const [newplayerSurName, setNewplayerSurname] = useState("");
    const [isLoaded, setIsLoaded] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();
    

    useEffect(() => {
        fetch(api.players().list().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setPlayers(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              // setError(error);
            }
          )
        if (props.tournament && props.tournament.type) {
            if (props.tournament.type.id < 4 || props.tournament.type.id === 5 || props.tournament.type.id === 9 || props.tournament.type.id === 10 || props.tournament.type.id > 12) {
                setIsDisabled(false);
            }
        }
    }, [props])
      
    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    const onNameChange = (event) => {
        setNewplayerName(event.target.value);
    };
    
    const onSurnameChange = (event) => {
        setNewplayerSurname(event.target.value);
    };

    async function onNewPlayer(e) {
        e.preventDefault()
        // console.warn('nome nuovo giocatore: ', newplayerName, ' ', newplayerSurName);
        const player = {
          "firstName": newplayerName,
          "lastName": newplayerSurName
        };

        const response = await fetch(api.players().create().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(player) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        // console.warn('stato di response: ', response);
        if (response.payLoad != null) {
          messageApi.success(`Giocatore ${response.payLoad.firstName} ${response.payLoad.lastName} aggiunto!`);
          setPlayers([...players,response.payLoad])
          setSelected([response.payLoad.id])
        }
        
    }

    async function onFinish(values) {
        // console.warn(values);
        const tournament = props.tournament;
        const bye = {};
        bye.tournamentId = tournament.id;
        bye.organizerId = tournament.leagueOrganizer;
        bye.playerId = values.player;
        bye.seasonLPI = { id: values.lpiSeason };
        // console.warn(bye);

        setConfirmLoading(true);
        const response = await fetch(api.byes().assign().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(bye) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        
        if (response.errorMsg === "") {
            setIsActive(false);
            messageApi.success("Bye successfully assigned!")
            window.location.reload(false);
        } else {
            setConfirmLoading(false);
            messageApi.error(`Error: ${response.errorMsg}`);
        }
    }

    // console.warn('props di AssignBye component:', props);
    const playerOpts = players.map((p) => {
        const fullName = p.firstName + ' ' + p.lastName;
        return (<Select.Option key={p.id} value={p.id}>{fullName}</Select.Option>)
    })
    const ls = (props.lpiSeasons.data && props.lpiSeasons.data.payLoad ? props.lpiSeasons.data.payLoad : []);
    return(
            <div>
                {contextHolder}
                <Modal title="Assign Bye" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Submit">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                        <Form.Item label="LPI Season" name="lpiSeason" rules={[{ required: true, message: t('common.requiredField') }]}>
                            <Select placeholder="Select Season">
                                {composeSelectOptions(ls,{key: 'id', value: 'id', desc: 'desc'})}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Bye Winner" name="player" rules={[{ required: true, message: t('common.requiredField') }]}>
                            <Select placeholder="Select Player"
                                value={selected}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                dropdownRender={(menu) => (
                                <>
                                    {menu}
                                    <Divider
                                        rootstyle={{
                                        margin: '8px 0',
                                        }}
                                    />
                                    <Space
                                        rootstyle={{
                                        padding: '0 8px 4px',
                                        }}
                                    >
                                        <Input
                                        placeholder="Nome"
                                        ref={nameRef}
                                        value={newplayerName}
                                        onChange={onNameChange}
                                        width="45%"
                                        />
                                        <Input
                                        placeholder="Cognome"
                                        ref={surnameRef}
                                        value={newplayerSurName}
                                        onChange={onSurnameChange}
                                        width="45%"
                                        />
                                    </Space>
                                    <Space>
                                    <Button type="text" icon={<PlusOutlined />} onClick={onNewPlayer}>
                                        New Player
                                        </Button>
                                    </Space>
                                </>
                            )}>
                                {playerOpts}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal} disabled={isDisabled}>
                    ASSIGN BYE
                </Button>
            </div>
    )
}

export default AssignBye;